import React, { useState } from 'react';
import empEmpty from "../../../assets/images/Group 1069addEmpEmpty.png"
import "./styleEmployee.css"

function AddEmployeeHome() {
    const [empList, setEmplist] = useState();
  return (
    <div className='add-employee-home'>
      <div className='add-employee-home-container'>
        <div className='emptyContainer'>
            <img src={empEmpty} alt='/'/>
            <p><span>No data,</span> please add Employees</p>
            <div className='AddEmpButtonEmpty'>Add Employees</div>
        </div>
      </div>
    </div>
  )
}

export default AddEmployeeHome
